const getAllGatewayIds = (wans) => {
  let wanGateways: string[] = [];
  for (var i = 0; i < wans.length; i++) {
    wanGateways.push(wans[i].activeServerId);
    if (wans[i].standbyServerId) {
      wanGateways.push(wans[i].standbyServerId);
    }
  }
  return wanGateways;
}

interface GatewayAvailability {
  hasNoTunnels: boolean;
  matchesController: boolean;
  isInWan: boolean;
  isLoadedServer: boolean;
}

export const isGatewayAvailableForSite = ({
  hasNoTunnels,
  matchesController,
  isInWan,
  isLoadedServer,
}: GatewayAvailability): boolean => {
  if (isInWan) {
    return false;
  }

  return (matchesController && hasNoTunnels) || isLoadedServer;
};

export default getAllGatewayIds;
